// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import type { ListingDetailsTransformer } from "../types";

type GetListing = {
  listingId: number,
  useV4?: boolean,
  include?: Array<string>,
  isJp?: boolean
};

const getListing = ({
  listingId,
  useV4 = false,
  include = [],
  isJp = true
}: GetListing): ((
  apiInstance: AxiosInstance
) => AxiosPromise<ListingDetailsTransformer>) => (apiInstance) => {
  // TODO: Refactor this when BE gets updated
  if (useV4 && isJp) {
    return apiInstance.get(`/v4/listings/${listingId}`);
  }

  if (useV4) {
    return apiInstance.get(`/v4/data/listings/${listingId}`);
  }

  return apiInstance.get(`/v5/listings/${listingId}`, {
    params: {
      include
    }
  });
};

export default getListing;
